export const PROGRAM_A_A_3D_ACCREDITATION = 'A_A_3_D_ACCREDITATION'
export const PROGRAM_ACCESSORIES_3D_ACCREDITATION =
  'ACCESSORIES_3_D_ACCREDITATION'
export const PROGRAM_SOFT_HOME_3D_ACCREDITATION = 'SOFT_HOME_3_D_ACCREDITATION'
export const PROGRAM_3D_STYLING = '_3_D_STYLING'
